import { Input, InputAdornment } from '@cian/ui-kit';
import { IconActionSearch16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './SubAgentSearchInput.css';

type TSubAgentSearchInput = {
  value: string;
  onChange: (value: string) => void;
  isLoading: boolean;
  isTopTabsRedesigned: boolean;
};

export const SubAgentSearchInput: React.FC<TSubAgentSearchInput> = ({
  value,
  onChange,
  isLoading,
  isTopTabsRedesigned,
}) => {
  return (
    <div className={styles['container']}>
      <Input
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        leftAdornment={
          <InputAdornment>
            <IconActionSearch16 />
          </InputAdornment>
        }
        size={isTopTabsRedesigned ? 'XS' : 'M'}
        loading={isLoading}
        placeholder="Введите имя сотрудника"
      />
    </div>
  );
};
